(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('revision', {
            parent: 'entity',
            url: '/revision',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.revision.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/revision/revisions.html',
                    controller: 'RevisionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('revision');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('revision-detail', {
            parent: 'entity',
            url: '/revision/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.revision.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/revision/revision-detail.html',
                    controller: 'RevisionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('revision');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Revision', function($stateParams, Revision) {
                    return Revision.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('revision.new', {
            parent: 'revision',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/revision/revision-dialog.html',
                    controller: 'RevisionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('revision', null, { reload: true });
                }, function() {
                    $state.go('revision');
                });
            }]
        })
        .state('revision.edit', {
            parent: 'revision',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/revision/revision-dialog.html',
                    controller: 'RevisionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Revision', function(Revision) {
                            return Revision.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('revision', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('revision.delete', {
            parent: 'revision',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/revision/revision-delete-dialog.html',
                    controller: 'RevisionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Revision', function(Revision) {
                            return Revision.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('revision', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
